module.exports = "/images/vendor/dhtmlx-scheduler/codebase/imgs_dhx_material/controls.png?1d098f1ab004b714e7ceca34be0e69f5";